import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ClaimsService } from 'src/app/core/services/claims.service';

@Injectable({
  providedIn: 'root',
})
export class ClaimActiveGuard {
  constructor(private router: Router, private claimsService: ClaimsService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // Extrai o claimId dos diferentes parâmetros possíveis
    const claimId =
      route.params['claimId'] ||
      route.params['id'] ||
      route.params['cid'] ||
      route.params['claim'];

    if (!claimId) {
      // Se não há claimId, permite acesso (caso edge)
      return true;
    }

    try {
      const claim = await this.claimsService.getClaimWithCase(claimId);

      if (!claim || claim.status !== 'ACTIVE') {
        // Antes de mostrar a modal de claim inativa, verifica se o usuário tem
        // outra claim ACTIVE no mesmo case (cenário de deduplicação / PoA do co-counsel).
        // Se tiver, redireciona para a mesma rota trocando o claim id pelo da ativa.
        if (claim?.case_id) {
          const activeClaim = await this.claimsService.getMyActiveClaimForCase(claim.case_id);
          if (activeClaim?.id && activeClaim.id !== claimId) {
            const newUrl = state.url.replace(claimId, activeClaim.id);
            this.router.navigateByUrl(newUrl);
            return false;
          }
        }

        // Redireciona para home com queryParam indicando claim inativa
        this.router.navigate(['/client/home'], {
          queryParams: { inactiveClaim: 'true', inactiveClaimId: claimId },
        });
        return false;
      }

      return true;
    } catch (error) {
      // Em caso de erro ao buscar claim, redireciona para home
      this.router.navigate(['/client/home'], {
        queryParams: { inactiveClaim: 'true', inactiveClaimId: claimId },
      });
      return false;
    }
  }
}
